/**
 * 本文中のテンプレート変数が許可されたもののみかどうかを判定する
 * @param {string} value - チェック対象の文字列
 * @return {boolean} 許可された変数のみならtrue、不正な変数や括弧の不一致があればfalse
 */
export function checkTemplateVariables(value = "") {
  // 1. テンプレート変数の候補をすべて抽出（{}のバランスが崩れているものも含む）
  //  { または {{ で始まり、 } または }} で終わるものを拾う
  const suspiciousPattern = /{{?[^{}]+}}?/g;
  const allCandidates: string[] = value.match(suspiciousPattern) || [];

  // 2. 候補の中で正しいものだけ抽出
  const validPattern = /^{{(NAME|COMPANY)}}$/;

  // 3. 候補のうち、正しいパターンに合致しないものがあればNG
  for (const candidate of allCandidates) {
    if (!validPattern.test(candidate)) {
      return false;
    }
  }

  // 4. 括弧の数（{ と }）が正しいかもチェック（念のため）
  const openingBraces = (value.match(/{/g) || []).length;
  const closingBraces = (value.match(/}/g) || []).length;
  if (openingBraces !== closingBraces) {
    return false;
  }

  return true;
}
